/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZodiacAries = createReactComponent("zodiac-aries", "IconZodiacAries", [
  ["path", { d: "M12 5a5 5 0 1 0 -4 8", key: "svg-0" }],
  ["path", { d: "M16 13a5 5 0 1 0 -4 -8", key: "svg-1" }],
  ["path", { d: "M12 21l0 -16", key: "svg-2" }]
]);

export { IconZodiacAries as default };
//# sourceMappingURL=IconZodiacAries.js.map
